import { __assign, __read, __rest } from "tslib";
import React, { forwardRef, useState } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
var DefaultStyle = {
// display: "flex",
// padding: "6px 16px",
// gap: "8px",
// minWidth: "200px",
// boxSizing: "border-box",
// color: "var(--tea-color-text-primary)",
// cursor: "pointer",
};
var DefaultStyleHover = {
// backgroundColor: "var(--tea-color-bg-primary-hover)",
};
export var ListItemButton = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, restProps = __rest(_a, ["children", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    var _b = __read(useState(false), 2), isHover = _b[0], setIsHover = _b[1];
    // const handleMouseEnter = useCallback(() => {
    //   setIsHover(true);
    // }, []);
    // const handleMouseLeave = useCallback(() => {
    //   setIsHover(false);
    // }, []);
    return (React.createElement("div", __assign({ className: classNames(classPrefix + "-list__item-button", className), style: __assign(__assign(__assign({}, DefaultStyle), style), (isHover ? DefaultStyleHover : {})), ref: ref }, restProps), children));
});
ListItemButton.displayName = "ListItemButton";
//# sourceMappingURL=ListItemButton.js.map